import { mutation_keys } from "../mutations";

/**
 * App action keys.
 * @type {import("../types/actions/sidebar").SidebarActionKeys}
 */
const sidebar_action_keys = {
    SET_SECTION: "SIDEBAR/SET_SECTION"
};

/**
 * App specific actions.
 * @type {import("../types/actions/sidebar").SidebarActions}
 */
const sidebar_actions = {
    /** Setting active sidebar section. */
    [sidebar_action_keys.SET_SECTION]: ({ commit }, section) => commit(mutation_keys.sidebar.SET_SECTION, section)
};

export { sidebar_action_keys };

export default sidebar_actions;